import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "content-video-feed",
  name: "短视频信息流",
  icon: "视",
  group: "信息流页面",
  description: "全屏纵向短视频流，按可见窗口管理播放器资源。",
  defaultProps: {
    "title": "推荐短视频",
    "layoutMode": "IMMERSIVE_VIDEO",
    "pageSize": 12,
    "autoplay": true,
    "muted": false,
    "loop": true,
    "showPublisher": true,
    "showInteraction": true
}
}
